import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// settings/platform.invoicePaymentEnabled: fakturabetaling er av til admin skrur den på.
export function useInvoiceFeature() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => onSnapshot(
    doc(db, 'settings', 'platform'),
    snap => { setEnabled(snap.data()?.invoicePaymentEnabled === true); setLoading(false); },
    () => { setEnabled(false); setLoading(false); },
  ), []);

  return { enabled, loading };
}
